// 文件下载与上传
<template>
    <div class="group">
        <el-row>
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="el-icon-edit"></i>
                        <span>文件下载与上传</span>
                    </div>
                    <div class="search-content mar_b">
                        <el-button type="info" @click="download" size="big">模板下载</el-button>
                        <el-button type="success" @click="exportExcelFile" size="big">导出进销存文件</el-button>
                        <el-button type="success" @click="exportExcelCZFileTemplate" size="big">导出查钻文件</el-button>
                        <el-button type="success" @click="exportExcelRapnetFileTemplate" size="big">导出rapnet文件</el-button>
                        
                    </div>
                    <!-- action="https://zjinsight.vip/seagullpj/params/uploadExcelFile" 
                        action="http://192.168.0.114:8080/ldspj/diamond/uploadExcelFile2"
                        action="https://www.ldsgia.com/ldspj/diamond/uploadExcelFile2"
                    -->
                    <div class="search-content mar_b">
                        <el-upload class="upload-demo" 
                                name = "fileList"
                                ref="upload" 
                                action="https://www.ldsgia.com/ldspj/diamond/uploadExcelFile2"
                                :auto-upload="false" 
                                :data="{user:user}"
                                :multiple="true" 
                                :before-upload="beforeUpload"
                                :on-success="handleSuccess"
                                :on-error="handleError"
                                :on-preview="handlePreview" 
                                :on-remove="handleRemove" >
                            <el-button type="primary" slot="trigger" size="big">选取文件</el-button>
                            <el-button type="success" @click="submitUpload" size="big">批量上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="font-size:20px">只能上传xls/xlsx格式的文件</div>
                        </el-upload>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    import cookieOperation from '../../common/js/cookieOperation';
    export default {
        data() {
            return {
                fileList: [],
                user:'admin',
                companyList: {
                    company_code: '',
                    company_name: '',
                },
                diamondInfoList: {},
                diamondCZInfoList: {},
                diamondRapnetInfoList: {}
                // userInfoAllList:[],
                // uploadForm : new FormData(),
            };
        },
        methods: {
            handleSuccess(res, file) {
                if (res.flag) {
                    if (res.code === 200) {
                        this.successMsg(res.msg);
                    }else if (res.code === 201) {
                        this.showMsg(res.msg);
                    }
                }else{
                    this.errorMsg(res.msg);
                }
                console.log(res);
            },
            handleError(res, file){
                this.errorMsg('上传失败');
                console.log(res);
                if ("502" == res.code) {
                    this.$router.push('/login');
                }
            },
            handlePreview(file) {
                console.log(file);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            beforeUpload(file) {
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    alert('上传附件只能是xls/xlsx格式！');
                    return false;
                }
            },
            submitUpload() {
                // 第一种上传 ref
                this.$refs.upload.submit();
                this.fileList = [];
            },
            /*
            // 导出进销存文件 ,可以根据前端选择不同的类型进行不同文件导出
            exportExcelFile() {
                let _this = this;
                util.publicget('/diamond/exportExcelFile', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        window.location.href = "/download/data/"+res.file_path;
                        _this.successMsg(res.msg);
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            
            // 导出文件 ,可以根据前端选择不同的类型进行不同文件导出
            exportExcelCZFileTemplate1() {
                let _this = this;
                util.publicget('/diamond/exportExcelCZFileTemplate', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        window.location.href = "/download/data/"+res.file_path;
                        _this.successMsg(res.msg);
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            */
            // 导出进销存文件
            exportExcelFile() {
                let _this = this;
                util.publicget('/diamond/queryJXCDaimondList', {
                }, function (res) {
                    if (res.flag) {
                        console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondInfoList = res.obj;
                            _this.exportJXCAll();
                        }else {
                            _this.errorMsg("导出失败！");
                        }
                    } else {
                        _this.errorMsg("导出失败！");
                    }
                });
            },
            // 导出进销存数据
            exportJXCAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['id','证书号','库存状态','销售状态','采购时间','下单时间'
                                ,'完成时间','地点','供应商','分数段','形状'
                                ,'重量','颜色','净度','切工','抛光'
                                ,'对称','荧光','证书','成本rap','成本折扣'
                                ,'货品成本','综合费点','美金成本','人民币成本'
                                ,'尺寸','台面','全深','比例','新折扣-上次'
                                ,'销售rap','新折扣','销售美元','销售汇率','售价'
                                ,'实收','利润','客户','备注','净度等级'
                                ,'付款日期','上架日期','证书日期','评价','货型'
                                ,'新旧折扣差','应收利润率','BT','BS','WT'
                                ,'WS','CLT','CS','EC','MILK','BR','GR'
                            ]
                    const filterVal = ['id','cert_no','inv_status','sale_status','buy_date','order_date'
                                ,'deal_date','place','supplier_rapid','carat_range','shape'
                                ,'ct','col','cla','cut','pol','sym'
                                ,'fl','cert','cost_rap','cost_dis','cost'
                                ,'point','usd_cost','rmb_cost','meas','table1'
                                ,'depth','ratio','new_dis_last','sale_rap','new_dis'
                                ,'sale_usd','sale_rate','sale_price','received_rmb','income'
                                ,'clients','remark','cla_level','pay_date','upload_date'
                                ,'cert_date','rating','para','dis_diff','profit_rate'
                                ,'bt','bs','wt','ws','clt'
                                ,'cs','ec','milk','br','gr']
                    const list = this.diamondInfoList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '钻石进销存数据')
                })
            },
            // 导出查钻文件
            exportExcelCZFileTemplate() {
                let _this = this;
                util.publicget('/diamond/queryCZDaimondList', {
                }, function (res) {
                    if (res.flag) {
                        console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondCZInfoList = res.obj;
                            _this.exportCZAll();
                        }else {
                            _this.errorMsg("导出失败！");
                        }
                    } else {
                        _this.errorMsg("导出失败！");
                    }
                });
            },
            // 导出查钻数据
            exportCZAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['stoneid','shape','carat','color','clarity'
                                ,'cut','polish','symmetry','fluorescence','milky'
                                ,'colsh','rmb','report','reportno','disount'
                                ,'address','measurement','rap','备注','状态'
                                ,'black','table','depth','eyeClean','BT'
                                ,'BC','WT','WC','是否报关','country'
                                ,'是否特价','预留字段','买汇率','买人民币','图片链接'
                                ,'视频链接','溯源码','海关核准单号','买折扣']
                    const filterVal = ['id','shape','ct','col','cla'
                                ,'cut','pol','sym','fl','milky'
                                ,'colsh','sale_price','cert','cert_no','new_dis'
                                ,'place','meas','sale_rap','remark','inv_status'
                                ,'black','table1','depth','eyeClean','BT'
                                ,'BC','WT','WC','是否报关','country'
                                ,'isdis','预留字段','买汇率','买人民币','图片链接'
                                ,'视频链接','溯源码','海关核准单号','买折扣']
                    const list = this.diamondCZInfoList
                    list.forEach(item =>{
                        this.$set(item,'isdis','是')
                        this.$set(item,'country','CHINA')
                        this.$set(item,'milky','无奶')
                        this.$set(item,'colsh','无咖')
                        this.$set(item,'remark','')
                        this.$set(item,'inv_status','在库')
                        this.$set(item,'eyeClean','EC0')
                        this.$set(item,'BT','BT0')
                        this.$set(item,'BC','BC0')
                        this.$set(item,'WT','WT0')
                        this.$set(item,'WC','WC0')
                        this.$set(item,'是否报关','已报关')
                    })
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '查钻上传数据')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            // 导出rapnet文件
            exportExcelRapnetFileTemplate() {
                let _this = this;
                util.publicget('/diamond/queryCZDaimondList', {
                }, function (res) {
                    if (res.flag) {
                        console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondRapnetInfoList = res.obj;
                            _this.exportRapnetAll();
                        }else {
                            _this.errorMsg("导出失败！");
                        }
                    } else {
                        _this.errorMsg("导出失败！");
                    }
                });
            },
            // 导出rapnet数据
            exportRapnetAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['Stock #','Availability','Shape','Weight','Color'
                        ,'Clarity','Cut Grade','Polish','Symmetry','Fluorescence Intensity'
                        ,'Fluorescence Color','Measurements','BGM','Eye Clean'
                        ,'Lab','Report #','RapLab Report ID','Treatment','RapNet Price'
                        ,'RapNet  Discount %','Cash Price','Cash Price Discount %','Depth %','Table %'
                        ,'Girdle Thin','Girdle Thick','Girdle %','Girdle Condition','Culet Size'
                        ,'Culet Condition','Crown Height','Crown Angle','Pavilion Depth','Pavilion Angle'
                        ,'Laser Inscription','Cert comment','Key to symbols','Member Comment','Star Length'
                        ,'Shade','White Inclusion','Black Inclusion','Open Inclusion','Milky'
                        ,'Fancy Color','Fancy Color Intensity','Fancy Color Overtone','Country','State'
                        ,'City','Brand','Seller Spec','Report Filename','Diamond Image'
                        ,'Video Link','Sarine Loupe','Trade Show','Report Issue Date','Report Type'
                        ,'Lab Location','Pair Stock #','Is Matched Pair Separable','Allow RapLink Feed','Parcel Stones']
                    const filterVal = ['id','Availability','shape','ct','col'
                        ,'cla','cut','pol','sym','fl'
                        ,'Fluorescence Color','meas','BGM','Eye Clean'
                        ,'Lab','cert_no','RapLab Report ID','Treatment','sale_usd'
                        ,'RapNet  Discount %','Cash Price','Cash Price Discount %','depth','table1'
                        ,'Girdle Thin','Girdle Thick','Girdle %','Girdle Condition','Culet Size'
                        ,'Culet Condition','Crown Height','Crown Angle','Pavilion Depth','Pavilion Angle'
                        ,'Laser Inscription','Cert comment','Key to symbols','Member Comment','Star Length'
                        ,'Shade','White Inclusion','Black Inclusion','Open Inclusion','Milky'
                        ,'Fancy Color','Fancy Color Intensity','Fancy Color Overtone','Country','State'
                        ,'City','Brand','Seller Spec','Report Filename','Diamond Image'
                        ,'Video Link','Sarine Loupe','Trade Show','Report Issue Date','Report Type'
                        ,'Lab Location','Pair Stock #','Is Matched Pair Separable','Allow RapLink Feed','Parcel Stones']
                    const list = this.diamondRapnetInfoList
                    list.forEach(item =>{
                        this.$set(item,'Availability','G')
                        this.$set(item,'BGM','no')
                        this.$set(item,'Eye Clean','yes')
                        this.$set(item,'Lab','GIA')
                        this.$set(item,'Laser Inscription','yes')
                        this.$set(item,'Member Comment','stone in SZ  wechat:18565895222 Skype:live:.cid.bab6686d2460340c  contact:18565895222')
                        this.$set(item,'Country','CHINA')
                        if(item.shape === '圆形'){
                            this.$set(item,'shape','round')
                        }else if(item.shape === '公主方') {
                            this.$set(item,'shape','princess')
                        }else if(item.shape === '雷迪恩') {
                            this.$set(item,'shape','radiant')
                        }else if(item.shape === '阿斯切') {
                            this.$set(item,'shape','asscher')
                        }else if(item.shape === '马眼形' || item.shape === '马眼') {
                            this.$set(item,'shape','marquise')
                        }else if(item.shape === '椭圆' || item.shape === '椭圆形') {
                            this.$set(item,'shape','oval')
                        }else if(item.shape === '祖母绿') {
                            this.$set(item,'shape','emerald')
                        }else if(item.shape === '梨形') {
                            this.$set(item,'shape','pear')
                        }else if(item.shape === '心形') {
                            this.$set(item,'shape','heart')
                        }else if(item.shape === '垫形') {
                            this.$set(item,'shape','cushion')
                        }else if(item.shape === '其他') {
                            this.$set(item,'shape','others')
                        }else if(item.shape === '三角形') {
                            this.$set(item,'shape','triangle')
                        }
                    })
                    console.log(list)
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, 'rapnet上传数据')
                })
            },
            // 导出文件 ,可以根据前端选择不同的类型进行不同文件导出
            exportExcelRapnetFileTemplate1() {
                let _this = this;
                util.publicget('/diamond/exportExcelRapnetFileTemplate', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        window.location.href = "/download/data/"+res.file_path;
                        _this.successMsg(res.msg);
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 模板下载
            download() {
                //let a = document.createElement('a');
                //a.href = '/static/钻石数据上传模板.xlsx';
                //a.download = '钻石数据上传模板.xlsx';
                //a.click();
                window.location.href = '/static/钻石数据上传模板.xlsx';
            },
            /*
            download() {
                let company_type = this.companyList.company_type;
                // 五类分类进行 文件下载
                if ('C' === company_type || '中介类' === company_type) {
                    window.location.href = '/download/cmodel.zip';
                } else if ('D' === company_type || '研发类' === company_type) {
                    window.location.href = '/download/dmodel.zip';
                } else if ('F' === company_type || '资金类' === company_type) {
                    window.location.href = '/download/fmodel.zip';
                } else if ('M' === company_type || '制造类' === company_type) {
                    window.location.href = '/download/mmodel.zip';
                } else if ('S' === company_type || '资源类' === company_type) {
                    window.location.href = '/download/smodel.zip';
                }
            },
            */
           /*
            // 查询企业基本信息表
            getCompanyInfoList() {
                let _this = this;
                util.publicget('/api/getCompanyList', {
                    equalsCompany_code: document.cookie.split(';')[3].split('=')[1]
                }, function (res) {
                    if (res.flag) {
                        _this.companyList.company_name = res.obj1[0].company_name;
                        _this.companyList.company_code = res.obj1[0].company_code;
                        _this.companyList.company_type = res.obj1[0].company_type;
                        _this.companyList.user_name = document.cookie.split(';')[1].split('=')[1];
                    } else {
                        _this.errorMsg('加载数据失败');
                    }
                });
            },*/
            /*download2(){
                let a = document.createElement('a');
                a.download = '111.xlsx';
                a.href = 'http://192.168.0.233:9200/download/';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            },*/
        },
        mounted() {
            // this.user = document.cookie.split(';')[1].split('=')[1];
            // user: document.cookie.split(';')[1].split('=')[1],
            this.user = sessionStorage.getItem('userName')
            //this.getCompanyInfoList();
        }
    };
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/procurement/fileUpload.vue